import Page from '@/features/dashboard/payments/pages/Success'

export default Page
